







































































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import LoginInformation from '@/views/login/components/LoginInformation.vue';
import LoginClubInformation from '@/views/login/components/LoginClubInformation.vue';
import LoginEventInformation from '@/views/login/components/LoginEventInformation.vue';
import LoginComunityInformation from '@/views/login/components/LoginComunityInformation.vue';
import LoginNewsList from '@/views/login/components/LoginNewsList.vue';
import LoginForm from '@/views/login/components/LoginForm.vue';
import LoginWebnarInncash from './components/LoginWebnarInncash.vue';

const eventBackgroundImage = require('@/assets/background/inncash-background-webinar-tax-reform.webp');
const defaultBackgroundImage = require('@/assets/background/inncash-background-2023.webp');
const comunityBackgroundImage = require('@/assets/background/inncash-comunity-call-background.webp');
const clubBackgroundImage = require('@/assets/background/inncash-background-club.webp');
const webnarBackGroundImage = require('@/assets/background/inncash-login-home-background-2026.webp');

@Component({
  components: {
    LoginInformation,
    LoginClubInformation,
    LoginEventInformation,
    LoginWebnarInncash,
    LoginComunityInformation,
    LoginNewsList,
    LoginForm,
  },
})
export default class Login extends Vue {
  get loginBackgroundImage(): string {
    switch (this.backgroundLoginType) {
      case 'event': return eventBackgroundImage;
      case 'club': return clubBackgroundImage;
      case 'webnar': return webnarBackGroundImage;
      case 'comunity': return comunityBackgroundImage;
      default: return defaultBackgroundImage;
    }
  }

  get backgroundLoginType(): string {
    return process.env.VUE_APP_LOGIN_TYPE ?? '';
  }
  get isMobileDeviceResolution(): boolean {
    return this.$vuetify.breakpoint.width < 960;
  }

  get isUltraWideDeviceResolution(): boolean {
    return this.$vuetify.breakpoint.width > 2164;
  }

  created(): void {
    this.$vuetify.theme.dark = false;
  }
}
